export function useLocation (props) {
  return props.location;
}

export function getQueryParam(props) {
  return new URLSearchParams(props.location.search.substring(1));
}

export function addAPIV3Host (uri) {
  return process.env.REACT_APP_APIV3_HOST+urlStage()+uri;
}

function urlStage () {
  const stage = process.env.REACT_APP_STAGEURI;
  return stage ? stage : "";
}
export function addWebHost(uri) {
  return 'https://7e6v8bfpg4.execute-api.us-west-2.amazonaws.com/dev/'+uri
  // need to move host to env variable, of course.
}

export function addHost (uri, type) {
  return type && type.toUpperCase() === "WEBHOST" ? addWebHost(uri) : addAPIV3Host(uri) 
}
